// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"52":"view-Login","160":"view-Index","212":"view-Score","670":"view-Detail","797":"view-ScoreForm"}[chunkId] || chunkId) + "." + {"52":"bdf35d33","160":"88af2bea","212":"3b1363c7","244":"1600e8d1","670":"2662c163","797":"51e78511","809":"9fd75f5d"}[chunkId] + ".js";
};